import { gql } from '@/core/shared/api';
import { content, fullContent } from './fragments.js';

export const getContent = async ({ commit, dispatch }) => {
  commit('setLoading', true);
  commit('content/set', {
    path: 'isLoadingContent',
    value: true,
  });

  try {
    const query = `{
      games (search: "") {
        ${content}
      }
    }`;

    const { games } = await gql.request(query);
    dispatch('insertEntities', {
      name: 'Content',
      payload: games,
    });
    return games;
  } finally {
    commit('setLoading', false);
    commit('content/set', {
      path: 'isLoadingContent',
      value: false,
    });
  }
};

export const getContentStationGames = async ({ commit, dispatch }, content) => {
  commit('setLoading', true);

  try {
    const query = `{
      game (id: "${content.id}") {
        ${fullContent}
      }
    }`;

    const { game } = await gql.request(query);
    dispatch('insertEntities', {
      name: 'Content',
      payload: game,
    });

    return game;
  } finally {
    commit('setLoading', false);
  }
};

export const getContentOnStation = async ({ commit, dispatch }, stationId) => {
  commit('setLoading', true);

  try {
    const query = `{
      stationGames (stationId: "${stationId}") {
        id
        imageUrl
        title
      }
    }`;
    const { stationGames } = await gql.request(query);

    const contentIds = dispatch('insertEntities', {
      name: 'Content',
      payload: stationGames,
    });

    return contentIds;
  } finally {
    commit('setLoading', false);
  }
};

export const remoteLaunchContent = async ({ commit, dispatch }, { stations, content }) => {
  commit('setLoading', true);

  const mutation = `mutation ($stations: [ StationInput ], $content: GameInput) {
    stationGameLaunch (stations: $stations, game: $content) {
      id
    }
  }`;

  try {
    const { stationGameLaunch } = await gql.request(mutation, { stations, content });

    dispatch('insertEntities', {
      name: 'Station',
      payload: stationGameLaunch,
    });

    return stationGameLaunch;
  } finally {
    commit('setLoading', false);
  }
};

export const remoteLaunchLauncher = async ({ commit, dispatch }, stations) => {
  commit('setLoading', true);

  const mutation = `mutation ($stations: [ StationInput ], $launcher: Boolean) {
    stationGameLaunch (stations: $stations, defaultLauncher: $launcher) {
      id
    }
  }`;

  try {
    const { stationGameLaunch } = await gql.request(mutation, { stations, launcher: true });

    dispatch('insertEntities', {
      name: 'Station',
      payload: stationGameLaunch,
    });

    return stationGameLaunch;
  } finally {
    commit('setLoading', false);
  }
};
